import { buildApiFromTlSchema } from './apiHelpers.ts';

const Api = buildApiFromTlSchema();

export default Api;
